import React from 'react'

/** Null during ordinary app use. The gated visual harness supplies invisible
 * readiness/error markers that must also exist inside native modal portals. */
export const VisualDiagnosticsContext = React.createContext<React.ReactNode>(null)
